{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "statistics": "Statistiques",
    "jurisdictions": "Juridictions",
    "pendingDisbursements": "Décaissements en attente",
    "payments": "Paiements",
    "taxpayers": "Contribuables",
    "firstPayment": "Premier paiement",
    "lastPayment": "Dernier paiement"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "administration-user": {
    "title": {
      "page": "Utilisateur",
      "page-taxpayer": "Les contribuables",
      "page-disable-tfa": "Désactiver l'authentification à double facteur (2FA)",
      "activation-link-confirmation": "Confirmer le lien d’activation"
    },
    "label": {
      "userName": "Nutzername",
      "department": "département",
      "roles": "Les rôles",
      "general-information": "Informations générales",
      "user": "Nouvel utilisateur",
      "edit-user": "Modifier l'utilisateur",
      "disabled": "Désactivée",
      "email-confirmed": "E-mail confirmé",
      "invitation-sent-at": "Invitation envoyée le",
      "invitation-not-sent": "Non envoyée",
      "locale": "Langue préférée",
      "disable": "Pour désactiver",
      "enable": "Activer",
      "cancel": "Annuler",
      "return": "Retour"
    },
    "button": {
      "send-activation-link": "Envoyer le lien d’activation",
      "resend-activation-link": "Renvoyer le lien d’activation"
    },
    "validations": {
      "userName": "Le nom d'utilisateur est requis"
    },
    "messages": {
      "disableTitle": "Désactiver l'utilisateur",
      "confirmDisable": "Voulez-vous vraiment désactiver cet utilisateur?",
      "confirmEnable": "Voulez-vous vraiment activer cet utilisateur?",
      "savedSucessfully": "Enregistré avec succès",
      "enableTitle": "Activer l'utilisateur",
      "error": "Erreur",
      "confirmDisableTfaTitle": "Désactiver 2FA",
      "confirmDisableTfa": "Voulez-vous vraiment désactiver l’authentification à deux facteurs pour l’utilisateur \"{0}\"?",
      "tfaDisabledSucessfully": "Authentification à double facteur désactivée avec succès",
      "activation-link-sent": "Lien d’activation envoyé",
      "confirm-send-activation-link": "Voulez-vous envoyer un lien d’activation à cet utilisateur ?",
      "confirm-resend-activation-link": "Voulez-vous renvoyer le lien d’activation à cet utilisateur ?"
    }
  },
  "user-profile": {
    "title": {
      "page": "Profil de l'utilisateur",
      "change-password": "Changer le mot de passe"
    },
    "label": {
      "userName": "Nom de l'utilisateur",
      "name": "nom",
      "email": "Email",
      "locale": "langue préférée",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "repeatPassword": "Répéter le mot de passe",
      "change-password": "Changer le mot de passe",
      "password": "Mot de passe"
    },
    "message": {
      "password-changed": "Le mot de passe a été changé avec succès",
      "profile-updated": "Mise à jour du profil réussie. Vous devez vous reconnecter pour voir les changements",
      "password": "Mettez à jour le mot de passe de votre compte pour assurer la sécurité de votre compte"
    }
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Maximum number of taxpayers",
      "durationProcess": "Durée jours",
      "descriptionProcess": "La description",
      "selectedTaxpayers": "Choisi",
      "excludedTaxpayers": "Exclu",
      "debtDetail": "Voir le détail de la dette",
      "lastTaxreturn": "Dernière déclaration",
      "lastPayment": "Dernier paiement",
      "excluded": "Exclu",
      "debtOriginal": "Dette initiale",
      "debtFinal": "Dette finale",
      "currentDebt": "Dette actuelle",
      "code": "Identifiant",
      "taxpayer": "Contribuable",
      "start": "Début",
      "end": "La fin",
      "newCommunication": "Nouvelle communication",
      "typeCommunication": "Canal de communication",
      "saveCommunication": "Enregistrer la communication",
      "communicationChannelPhone": "Téléphone",
      "communicationChannelMail": "Courrier électronique",
      "process": "Traiter",
      "startProcess": "Processus démarré",
      "recoveredDebt": "Dette recouvrée",
      "endProcess": "Processus final",
      "timeElapsed": "Réponse moyenne",
      "countProcess": "Processus",
      "countEndedProcess": "Achevé",
      "countInProgressProcess": "En procès",
      "countTaxpayerProcess": "Contribuables",
      "unpaid": "Non payé",
      "noCommunications": "Aucune communication"
    },
    "title": {
      "detailCollection": "Informations de paiement",
      "newProcessCollection": "Nouveau processus de collecte",
      "selectionTaxpayerProcess": "Sélection des contribuables",
      "indicators": "Indicateurs",
      "taxreturnAndPayments": "Déclarations et paiements d'impôts",
      "communications": "Communication",
      "processCollection": "Processus de collecte",
      "StatisticQuery": "Période de consultation",
      "StatisticQueryResult": "Résultats"
    },
    "status": {
      "started": "A débuté",
      "ended": "Terminé"
    },
    "messages": {
      "newProcessCreated": "n nouveau processus de collecte a été créé avec [limit] contribuables qui a commencé le [startDate] et se termine le [endDate]"
    }
  },
  "common": {
    "label": {
      "valueType": "Type de valeur",
      "theme": "Thème",
      "feedback": "Retour d'information",
      "logout": "Se déconnecter",
      "print": "Imprimer",
      "phoneNumberArea": "Indicatif",
      "newRecord": "Nouveau",
      "editRecord": "Aktualisieren",
      "current-user": "Utilisateur actuel",
      "user-profile": "Profil de l'utilisateur",
      "name": "nom",
      "givenNames": "Noms",
      "surnames": "Prénoms",
      "search": "Chercher",
      "clean": "Nettoyer",
      "create": "Nouveau",
      "ok": "Accepter",
      "next": "Suivant",
      "cancel": "Annuler",
      "back": "Retourner",
      "edit": "Éditer",
      "actions": "Actions",
      "selectAction": "Sélectionner une action",
      "send": "Envoyer",
      "close": "Fermer",
      "add": "Ajouter",
      "email": "Email",
      "phoneNumber": "Téléphone",
      "id": "Va",
      "password": "Mot de passe",
      "state": "Désactivée",
      "translation": "Übersetzung",
      "language": "langage",
      "value": "Wert",
      "translatable": "Übersetzbar",
      "politicalDivision": "Division politique",
      "department": "Département / Province / État",
      "city": "Ville",
      "zipCode": "Poste",
      "cellPhone": "Mobile",
      "personType": "Genre de personne",
      "businessName": "Nom ou raison sociale",
      "taxpayerName": "Nom ou raison sociale",
      "tradeName": "Handelsname",
      "address": "Adresse",
      "country": "Pays",
      "localization": "Emplacement",
      "website": "Site web",
      "fileSearch": "Rechercher un fichier",
      "fileRequirements": "PDF · Max. 9,6 Mo",
      "fileUploading": "Téléversement...",
      "fileUploaded": "Téléversé",
      "fileUploadError": "Le fichier n’a pas pu être téléversé",
      "fileSelect": "Sélectionner",
      "fileReplace": "Remplacer",
      "fileRemove": "Supprimer",
      "fileRemoving": "Suppression...",
      "fileRemoveError": "Le fichier n’a pas pu être supprimé",
      "fileUpload": "Datei hochladen",
      "fileDownload": "Télécharger un fichier",
      "noFileSelected": "Aucun fichier choisi",
      "dateFrom": "Dater de",
      "dateTo": "Date au",
      "noFound": "Il n'y a pas de résultat",
      "taxReturnCurrency": "Déclaration de devise",
      "page-showing": "Montrant",
      "page-to": "à",
      "page-of": "de",
      "page-entries": "records",
      "loading": "Mise en charge...",
      "error": "Erreur",
      "unableToLoad": "Impossible de charger les données. Veuillez réessayer.",
      "retry": "Réessayer",
      "currency": "Devise",
      "paymentMethod": "Procédé de paiement",
      "attachment": "Attacher",
      "paymentReference": "Plus d'informations",
      "supportDocument": "Document d'assistance",
      "payment": "Paiement",
      "backToHome": "Retour au début",
      "createdBy": "Créé par",
      "bank": "Banque",
      "bankInformation": "Informations bancaires",
      "excel": "Excel",
      "days": {
        "monday": "lun",
        "tuesday": "Ma",
        "wednesday": "Mich",
        "thursday": "Je ",
        "friday": "ven",
        "saturday": "Sam",
        "sunday": "Di"
      },
      "months": {
        "january": "janvier",
        "february": "février",
        "march": "Mars",
        "april": "avril",
        "may": "Mai",
        "june": "juin",
        "july": "juillet",
        "august": "août",
        "september": "septembre",
        "october": "Octobre",
        "november": "novembre",
        "december": "décembre"
      },
      "type": "Type",
      "numeric": "Numérique",
      "date": "Date",
      "list": "Prêt",
      "text": "Texte",
      "header": "Tête de lit",
      "description": "La description",
      "ommited": "Omis",
      "all": "Tout",
      "see": "Voir",
      "filters": "Filtres"
    },
    "descriptions": {
      "taxReturnCurrency": "Monnaie à utiliser pour les déclarations",
      "can-access": "Permet d'accéder à",
      "contactTaxIdNumber-tax": "Numéro d'identification fiscale du contact dans le pays de résidence"
    },
    "button": {
      "add": "Ajouter",
      "edit": "Éditer",
      "find": "Chercher",
      "cancel": "Annuler",
      "delete": "Se débarrasser de",
      "save": "Enregistrer",
      "clean": "Nettoyer",
      "new": "Nouveau",
      "show": "Regarder",
      "download": "Télécharger",
      "file": "Attacher",
      "previous": "Précédent",
      "next": "Suivant",
      "send": "Envoyer",
      "translate": "Traductions",
      "return": "Revenir",
      "continue": "continuer",
      "newVersion": "Nouvelle version"
    },
    "dialog": {
      "dialog-error": "Erreurs",
      "table-title-header": "messages",
      "warning-title": "Attention"
    },
    "messages": {
      "error-500": "Une erreur s'est produite sur le serveur, veuillez contacter l'administrateur.",
      "fileUpload": "Le fichier a été téléchargé avec succès",
      "savedSucessfully": "Stocké avec succès",
      "deletedSucessfully": "Supprimé avec succès",
      "pleaseWait": "S'il-vous-plaît attendez",
      "nofileContent": "Le fichier n'a pas de contenu",
      "errorMessageSystem": "Le paramètre '$ {code}' est introuvable dans le catalogue",
      "warningInactiveSession": "Attention: aucune activité n'a été détectée depuis un certain temps. La session sera fermée dans 1 minute si aucune activité n'est encore détectée",
      "sessionIdleCountdown": "Votre session se fermera dans {{count}} secondes.",
      "closingSession": "Séance de clôture ...",
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?",
      "uploadProcessing": "Les informations ont été téléchargées et sont en cours de traitement, vous serez averti une fois le traitement terminé.",
      "messageSent": "Message envoyé avec succès"
    },
    "validations": {
      "nameRequired": "Il est requis de compléter le champ correspondant au nom",
      "fieldRequired": "Ce champ est requis",
      "numbersAndLetters": "Seulement des chiffres et des lettres",
      "email": "Email invalide",
      "minStringValue": "Le champ doit contenir au moins {{min}} caractères",
      "maxStringValue": "Le champ doit contenir au maximum {{max}} caractères",
      "minNumberValue": "La valeur du champ doit être minimale {{min}}",
      "maxNumberValue": "La valeur du champ doit être au maximum {{max}}"
    },
    "languages": {
      "spanish": "Espagnol (Espagne)",
      "english": "États Unis Anglais)"
    },
    "taxpayer-request-types": {
      "enroll": "Enregistrement",
      "update": "Aktualisierung"
    },
    "taxpayer-request-states": {
      "pending": "En attente",
      "pending_additional_information": "En attente d'informations supplémentaires",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Rectifier",
      "unsubscribe": "Se désabonner"
    },
    "taxreturn-status": {
      "pending": "En attente",
      "accepted": "Accepté",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "reconciled": "Réconcilié"
    },
    "yes-no": {
      "yes": "Ja",
      "no": "NE PAS"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "Pour le pays",
      "taxpayerByOperation": "Par opération",
      "taxpayerAmount": "Quantité",
      "taxAmount": "Par taxe",
      "dateFrom": "Date de",
      "dateTo": "Date au"
    },
    "title": {
      "pageTaxpayer": "Les contribuables",
      "pageTaxreturn": "Déclarations",
      "pagePayment": "Paiements"
    },
    "validations": {
      "dateRequired": "Cette date est obligatoire",
      "dateToGreaterThan": "La date doit être postérieure à la date de début",
      "dateLessThreeMonths": "La date doit être inférieure à 12 mois à compter de la date de début"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Boites aux lettres"
    },
    "label": {
      "message": "message",
      "messages": "messages",
      "read": "Lis",
      "inboxDate": "Date",
      "ok": "OUI",
      "no": "NE PAS"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconnexion",
      "reconected": "Reconnecté"
    }
  },
  "non-compliances": {
    "label": {
      "period": "Période",
      "expirationDate": "Date d'expiration",
      "NotificationDate": "Date de notification",
      "presentationDate": "Date de présentation",
      "wait": "Attendre",
      "penalty": "Peine",
      "declarationAmount": "Montant de la déclaration",
      "paymentAmount": "Montant du paiement",
      "days": "jours",
      "countTaxpayerNotified": "Avis",
      "countTaxpayerCompliance": "Compliments",
      "compliancePercentage": "Conformité",
      "elapsedTime": "Temps moyen",
      "debtGenerated": "Dette générée"
    },
    "title": {
      "nonCompliancesTax": "Non-conformité due à la fiscalité",
      "nonCompliances": "Non-conformités",
      "nonCompliancesPayments": "Les paiements en suspens",
      "StatisticQuery": "Période de consultation",
      "StatisticQueryResult": "Résultats"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "Activité économique"
    },
    "label": {
      "code": "Code",
      "name": "nom",
      "description": "La description",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer"
    },
    "header": {
      "code": "Code",
      "name": "nom",
      "description": "La description",
      "actions": "Actions"
    },
    "button": {
      "cancel": "Annuler",
      "delete": "Se débarrasser de",
      "save": "Enregistrer",
      "search": "Chercher",
      "new": "Nouveau",
      "clean": "Nettoyer",
      "ok": "Accepter"
    },
    "validations": {
      "codeRequired": "Le code est obligatoire",
      "nameRequired": "Le nom est obligatoire",
      "descriptionRequired": "La description est requise"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir supprimer ces informations?",
      "deletedSucessfully": "A été supprimé avec succès",
      "savedSucessfully": "Informations stockées",
      "error": "Erreur"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Traitement",
      "error": "Erreur",
      "accepted": "Accepté",
      "processed": "Traité"
    },
    "title": {
      "page": "Consultation des rapports"
    },
    "label": {
      "reportNumber": "Signaler le numéro",
      "reportType": "Type de rapport",
      "operations": "type d'opération",
      "taxpayerNumber": "Ruc",
      "taxpayerName": "Nom du contribuable",
      "registrationDate": "Date d'enregistrement",
      "period": "période",
      "reportName": "Nom du rapport",
      "record": "Valeurs",
      "index": "Ligne",
      "type": "Nett",
      "active": "actif",
      "taxReportState": "État"
    }
  },
  "payment-file-status": {
    "processing": "En traitement",
    "error": "Erreur",
    "pending": "En attente",
    "accepted": "Accepté",
    "rejected": "Rejeté",
    "processed": "Traité",
    "received": "Reçu"
  },
  "taxreturn-report": {
    "title": {
      "page": "Voir les déclarations"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "taxreturnNumber": "Numéro de déclaration",
      "country": "Pays",
      "formId": "Nom de forme",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "name": "Nom du contribuable",
      "period": "Période",
      "periodFrom": "Dater de",
      "periodTo": "Date jusqu'au",
      "active": "actif",
      "overview": "général",
      "taxreturn": "Déclaration",
      "createDate": "Date",
      "approve": "Approuvé",
      "comments": "commentaires"
    },
    "header": {
      "actions": "Actions",
      "nit": "Numéro d'identification fiscale",
      "name": "Nom du contribuable",
      "taxReturnNumber": "Numéro de déclaration",
      "createDate": "Date",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "form": "Forme",
      "period": "Période",
      "active": "actif",
      "rejectionReason": "Raison du rejet"
    },
    "validations": {},
    "messages": {
      "periodMessage": "Pour les périodes annuelles au format AAAA, période mensuelle / trimestrielle AAAAMM"
    },
    "button": {}
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Examen des rectifications",
      "approve": "Approuver la rectification",
      "reject": "Rejeter la rectification",
      "dialog-confirm": "Confirmer"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "taxreturnNumber": "Numéro de déclaration",
      "country": "Pays",
      "taxId": "Impôt",
      "taxreturnType": "Type de déclaration",
      "name": "Numéro de contribuable",
      "form": "Forme",
      "approve": "Passe",
      "taxpayer": "Contribuable",
      "comments": "commentaires",
      "general-comments": "Dater de",
      "periodFrom": "Date jusqu'au",
      "periodTo": "Observations générales"
    },
    "header": {
      "actions": "Actions",
      "nit": "Numéro d'identification fiscale",
      "name": "Nom du contribuable",
      "taxReturnNumber": "Numéro de contribuable",
      "form": "Forme",
      "tax": "Impôt",
      "taxreturnStatus": "État",
      "period": "Période",
      "createDate": "Date"
    },
    "validations": {},
    "messages": {
      "approved": "Déclaration approuvée",
      "rejected": "Déclaration rejetée",
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?"
    },
    "button": {
      "reject": "Rejeter",
      "approve": "Passe"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Type de catalogue",
      "catalog": "Catalogue"
    },
    "label": {
      "type": "Nett",
      "name": "nom",
      "description": "La description",
      "field": "Campagne",
      "label": "Hashtag",
      "parent": "Papa",
      "newCatalogType": "nouveau type de catalogue",
      "newCatalog": "Nouveau catalogue",
      "code": "Code",
      "addDefinition": "Ajouter une définition",
      "newDefinition": "Nouvelle définition",
      "extaFilds": "Champs utilisateur supplémentaires",
      "addNameTraslation": "Ajouter une traduction"
    },
    "validations": {
      "exists": "L'enregistrement existe déjà",
      "letterNumberhyphen": "Seuls les lettres, les chiffres et les traits d'union sont autorisés"
    },
    "messages": {
      "languageExist": "La langue a déjà été ajoutée"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Variables d'environnement (sécurité)",
      "page-application": "Variables d'environnement (application)"
    },
    "label": {
      "name": "nom",
      "type": "Nett",
      "value": "Wert",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer"
    },
    "validations": {
      "nameRequired": "Il est requis de compléter le champ correspondant au nom",
      "typeRequired": "Le champ Type est obligatoire",
      "textValueRequired": "Le champ Valeur est obligatoire"
    },
    "messages": {
      "savedSucessfully": "Enregistré de manière satisfaisante",
      "error": "Erreur"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Modèle de page de destination",
      "page-terms": "Termes et conditions du modèle"
    },
    "label": {
      "template": "Modèle"
    },
    "messages": {
      "savedSucessfully": "Enregistré avec succès"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "Application de notifications",
      "page-security": "Notifications de sécurité"
    },
    "label": {
      "template": "Modèle",
      "emailNotification": "Notifier par e-mail",
      "pushNotification": "Notifier la boîte aux lettres",
      "newTemplate": "Nouveau modèle",
      "id": "Modèle d'identifiant",
      "subject": "Subject",
      "inbox": "Plateau"
    },
    "validations": {
      "templateRequired": "Le modèle est requis"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Champs du contribuable",
      "enabled": "Activée"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "nom",
      "fieldSection": "Section",
      "actions": "Activée"
    },
    "messages": {
      "savedSucessfully": "Informations stockées avec succès"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Clés API"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nouvelle clé",
      "expiration": "Date d'expiration",
      "your-pat": "Votre nouveau Personal Access Token",
      "revoke-token": "Révoquer le token"
    },
    "validations": {
      "name": "Le nom de la clé Api est requis",
      "expiration": "La date d'expiration est requise"
    },
    "message": {
      "key-created": "Assurez-vous de l'enregistrer - vous ne pourrez plus y accéder.",
      "confirm-revoke": "Voulez-vous vraiment révoquer le token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Journaux d'événements",
      "http-title": "Journaux HTTP",
      "application": "App",
      "security": "Sécurité"
    },
    "label": {
      "dateFrom": "Dater de",
      "dateTo": "Date jusqu'au",
      "user": "Utilisateur",
      "aggregateName": "Requête de nom",
      "eventName": "Nom de l'événement",
      "httpMethod": "Méthode HTTP",
      "httpStatusCode": "Code d'état HTTP",
      "id": "Identifiant",
      "date": "Date",
      "url": "URL",
      "ip": "IP",
      "type": "Type de requête",
      "consultation": "Consultation",
      "modification": "Modification"
    },
    "header": {},
    "validations": {
      "dateRequired": "Cette date est obligatoire",
      "dateToGreaterThan": "La date doit être postérieure à la date de début",
      "dateLessThreeMonths": "La date doit être inférieure à 3 mois à compter de la date de début"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Désactiver l'authentification à deux facteurs (2FA)",
      "disable": "Désactiver 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Cette action désactive uniquement 2FA.",
      "alert-2": "La désactivation de 2FA ne modifie pas les clés utilisées dans les applications d'authentification.",
      "alert-3": "Si vous souhaitez modifier la clé utilisée dans une application d'authentification, vous devez:",
      "alert-4": "réinitialisez vos clés d'authentification.",
      "success": "2fa a été désactivé. Vous pouvez réactiver 2fa lorsque vous configurez une application d'authentification"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurer l'application d'authentification",
      "verification-code": "Verifizierungs-Schlüssel",
      "verification-code-digit": "Chiffre {{position}} sur {{total}}",
      "verify": "prüfen",
      "manual-key": "Clé de configuration manuelle",
      "copy-key": "Copier la clé",
      "key-copied": "Clé copiée dans le presse-papiers.",
      "key-copied-button": "Copié",
      "copy-unavailable": "La clé n'a pas pu être copiée. Copiez-la manuellement.",
      "security-recommendations": "Recommandations de sécurité",
      "security-recommendations-detail": "Conservez les codes de récupération dans un endroit sûr et ne partagez pas la clé de configuration."
    },
    "validations": {
      "code": "Le code de vérification est requis"
    },
    "message": {
      "instruction-1": "Téléchargez une application d'authentification telle que Microsoft Authenticator pour",
      "and": "Oui",
      "or": "ou alors",
      "for": "afin de",
      "instruction-2": "Scannez le code QR ou insérez cette clé",
      "instruction-3": "dans votre application d'authentification. Les espaces et les séparateurs n'ont pas d'importance.",
      "instruction-4": " Une fois que vous avez scanné le code QR ou saisi la clé ci-dessus, votre application d'authentification vous fournira un code unique. Entrez le code dans le champ de confirmation ci-dessous."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Codes de récupération",
      "available-once": "Enregistrez-les maintenant : ils ne seront plus affichés intégralement."
    },
    "message": {
      "save-security-codes": "Conservez ces codes dans un endroit sûr.",
      "if-you-lose": "Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Générer des codes de récupération pour l'authentification à deux facteurs (2FA)",
      "generate": "Générer des codes de récupération"
    },
    "validations": {},
    "message": {
      "alert-1": "Mettez ces codes dans un endroit sûr.",
      "alert-2": " Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte.",
      "alert-3": " Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte.",
      "alert-4": " réinitialisez vos clés d'authentification."
    }
  },
  "security-login": {
    "title": {
      "login": "Connexion"
    },
    "label": {
      "username": "Utilisateur",
      "password": "Mot de passe",
      "rememberMe": "Souviens-toi de moi",
      "loginButton": "Commencer la session",
      "passwordRecovery": "Récupérer le mot de passe",
      "notRegistered": "Pas encore inscrit?",
      "signup": "S'inscrire",
      "loginAlternative": "ou alors",
      "forgotPassword": " Vous avez oublié votre mot de passe ?",
      "next": "Suivant",
      "forgotPasswordInstructions": "Entrez votre nom d'utilisateur et nous vous enverrons un e-mail avec les instructions pour récupérer",
      "externalLogin": "Connexion externe",
      "captcha-placeholder": "Entrez Captcha"
    },
    "validations": {
      "usernameRequired": "Le champ utilisateur est obligatoire",
      "passwordRequired": "Mot de passe requis",
      "captchaValidationRequired": "La validation du captcha est requise"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Zwei-Faktor-Authentifizierung",
      "login-recovery": "Récupérer le code de vérification"
    },
    "label": {
      "twoFactorCode": "Code d'authentification",
      "recoveryCode": "Code de récupération",
      "rememberBrowser": "Souvenez-vous de ce navigateur",
      "verificationCodeInstructions": "Saisissez le code à six chiffres de votre application d'authentification pour continuer.",
      "loginButton": "login",
      "loginRecovery": "Connectez-vous avec le code de récupération"
    },
    "message": {
      "no-access": "Vous n'avez pas accès à votre appareil d'authentification? tu peux",
      "trustedBrowser": "Ignorez la vérification dans ce navigateur de confiance.",
      "recovery-requested": " Vous avez demandé à vous connecter avec un code de récupération. Cette connexion ne sera pas mémorisée tant que vous n'aurez pas fourni un code d'application d'authentification lors de la connexion ou désactivez 2FA et reconnectez-vous."
    },
    "validations": {
      "twoFactorCode": "Le champ du code d'authentification est obligatoire",
      "recoveryCode": "Le champ du code de récupération est obligatoire"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Récupérer le mot de passe",
      "changePassword": "Changer le mot de passe",
      "userName": "Utilisateur",
      "newPassword": "nouveau mot de passe",
      "repeatPassword": "Répéter le mot de passe",
      "returnLogin": "Revenir à la connexion"
    },
    "message": {
      "email-sended": "E-mail de récupération de mot de passe envoyé",
      "password-changed": "Le mot de passe a été modifié avec succès"
    },
    "validations": {
      "newPassword": "Le nouveau mot de passe doit comporter au moins 6 caractères",
      "passwordEqual": "Les mots de passe ne correspondent pas"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Installer l'application d'authentification",
      "reset": "Réinitialiser la clé d'authentification",
      "configure": "Configurer l'application d'authentification"
    },
    "validations": {},
    "message": {
      "alert-1": "Si vous réinitialisez votre clé d'authentification, votre application d'authentification ne fonctionnera pas tant que vous ne l'aurez pas reconfigurée.",
      "alert-2": "Ce processus désactive 2FA jusqu'à ce que vous vérifiiez votre application d'authentification.",
      "alert-3": "Si vous ne terminez pas la configuration de votre application d'authentification, vous risquez de perdre l'accès à votre compte.",
      "success": "Ihr Authentifizierungsschlüssel wurde zurückgesetzt und Sie müssen Ihre Authentifizierungs-App mit dem neuen Schlüssel konfigurieren."
    }
  },
  "tfa": {
    "title": {
      "page": "Authentification à deux facteurs"
    },
    "label": {
      "title": "Authentification à deux facteurs (2FA)",
      "authenticator-app": "Application d'authentification",
      "setup-authenticator": "Configurer l'application d'authentification",
      "add-authenticator": "Ajouter une application d'authentification",
      "reset-authenticator": "Redémarrez l'application d'authentification",
      "reset-recovery-codes": "Réinitialiser les codes de récupération",
      "disable-2fa": "Désactiver 2FA",
      "forget-this-browser": "Oubliez ce navigateur",
      "status-enabled": "Activé",
      "status-disabled": "Non configuré",
      "recovery-codes-remaining": "codes de récupération disponibles",
      "danger-zone": "Actions à fort impact"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Ce navigateur a été oublié. Lorsque vous vous reconnecterez dans ce navigateur, votre code 2fa vous sera demandé.",
      "no-codes-left-1": "Sie haben keine Wiederherstellungscodes verfügbar.",
      "no-codes-left-2": "Sollte",
      "no-codes-left-3": "générer un nouvel ensemble de codes de récupération",
      "no-codes-left-4": "avant de pouvoir vous connecter avec un code de récupération.",
      "some-codes-left-1": "Haben",
      "some-codes-left-2": "code (s) de récupération disponible.",
      "some-codes-left-3": "Sollte",
      "some-codes-left-4": "générer un nouvel ensemble de codes de récupération"
    }
  },
  "roles": {
    "account_reports": "Consultation de compte",
    "catalogs_admin": "Gestionnaire de catalogue",
    "details_reports": "Détails des rapports",
    "environments_admin": "Gestionnaire de variables d'environnement",
    "forms_admin": "Gestionnaire de formulaires",
    "management_report_admin": "Gestionnaire de rapports",
    "notifications_admin": "Gestionnaire de notifications",
    "system_auditor": "Auditeur système",
    "taxpayer_reports": "Demandes de renseignements des contribuables",
    "taxpayers_admin": "Administrateur des contribuables",
    "payments_admin": "Gestionnaire de paiement",
    "taxpayers_approver": "Approbateur des contribuables",
    "taxreturn_approver": "Approbateur des déclarations",
    "taxreturn_reports": "Requêtes sur les déclarations",
    "tfa_admin": "Administrateur 2FA",
    "users_admin": "Administrateur des utilisateurs",
    "current_account_admin": "Gestionnaire de compte actuel",
    "debt_collection_analyst": "Analyste en recouvrement de créances",
    "debt_collection_manager": "Chargé de recouvrement",
    "debt_collection_officer": "Agent de recouvrement",
    "taxpayer_communication": "Communication aux contribuables",
    "non_compliance_analyst": "Analyste de non-conformité",
    "collection_statistics": "Analyse des collections",
    "compliance_statistics": "Analyse de non-conformité"
  },
  "taxes": {
    "title": {
      "page": "Gérer les taxes"
    },
    "label": {
      "name": "nom",
      "rateType": "Type de taux",
      "shortName": "Nom court",
      "code": "Code",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer",
      "tabEditTax": "général",
      "tabRates": "honoraires",
      "rate": "Taux",
      "tabPeriodicity": "Périodicité",
      "tabOperations": "Opérations",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "value": "Wert",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration",
      "paymentDueDay": "Jour de paiement"
    },
    "header": {
      "code": "Code",
      "name": "nom",
      "rateType": "Type de taux",
      "value": "Wert",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "shortName": "Nom court",
      "actions": "Actions",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "validations": {
      "rateTypeRequired": "Le champ de type de taux est obligatoire",
      "shortNameRequired": "Le champ du nom court est obligatoire",
      "codeRequired": "Le champ de code est obligatoire",
      "valueLessThan100": "Le champ de valeur doit être inférieur à 100%",
      "valueRequired": "Le champ de valeur est obligatoire",
      "dateFromRequired": "La date du champ est obligatoire",
      "dateToRequired": "Le champ date à est obligatoire",
      "filingDueDayRequired": "Le champ du jour d'expiration est obligatoire",
      "periodicityTypeRequired": "Le champ de type de périodicité est obligatoire"
    },
    "messages": {
      "savedSuccessfully": "A été enregistré avec succès",
      "deletedSuccessfully": "A été supprimé avec succès",
      "error": "Erreur"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Gérer les rapports d'opérations",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Opération",
      "report": "Signaler"
    },
    "header": {
      "operation": "Opération",
      "report": "Signaler",
      "actions": "Actions"
    },
    "messages": {
      "removeReportOperation": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "reports": {
    "title": {
      "page": "Gérer les rapports",
      "report": "Signaler",
      "versions": "Versionen"
    },
    "label": {
      "name": "nom",
      "shortName": "Nom court",
      "code": "Code",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer",
      "tabEditReport": "général",
      "tabPeriodicity": "Périodicité",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "header": {
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "actions": "Actions",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "validations": {
      "shortNameRequired": "Le champ du nom court est obligatoire",
      "codeRequired": "Le champ de code est obligatoire",
      "dateFromRequired": "La date du champ est obligatoire",
      "dateToRequired": "Le champ date à est obligatoire",
      "filingDueDayRequired": "Le champ du jour d'expiration est obligatoire",
      "periodicityTypeRequired": "Le champ de type de périodicité est obligatoire"
    },
    "messages": {
      "savedSuccessfully": "A été enregistré avec succès",
      "deletedSuccessfully": "A été supprimé avec succès",
      "error": "Erreur"
    }
  },
  "report-cells": {
    "title": {
      "page": "Des boites"
    },
    "label": {
      "code": "Code de boîte",
      "name": "Boîte de nom",
      "description": "La description",
      "formula": "Formule",
      "order": "Ordre",
      "type": "Nett",
      "numeric": "Numérique",
      "currency": "Devise",
      "date": "Date",
      "list": "Prêt",
      "text": "Texte",
      "catalogType": "Type de catalogue",
      "mandatory": "Obligatoire"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Es-tu sûr de vouloir le supprimer?"
    }
  },
  "report-version": {
    "title": {
      "page": "Rapport de version"
    },
    "label": {
      "version": "Ausführung",
      "formVersion": "Rapport de version",
      "startDate": "Dater de",
      "endDate": "Date au",
      "formCode": "Code",
      "formName": "nom",
      "since": "Depuis",
      "tabVersion": "Ausführung",
      "fields": "Des boites"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Gérer les opérations fiscales",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Opération",
      "tax": "Impôt"
    },
    "header": {
      "operation": "Opération",
      "tax": "Impôt",
      "actions": "Actions"
    },
    "messages": {
      "removeTaxOperation": "Êtes-vous sûr de vouloir le supprimer?",
      "allOperationsLinked": "Toutes les opérations sont déjà associées à cette taxe",
      "noLinkedOperations": "Aucune opération n’est associée à cette taxe"
    }
  },
  "penalties": {
    "label": {
      "periodFrom": "Période de",
      "periodTo": "Période à"
    },
    "title": {
      "listPenalties": "Configuration des pénalités"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Compte courant",
      "amendingCredit": "Demande de solde",
      "currentAccountTransaction": "Détail des transactions",
      "transactionAdjustment": "Ajustement de la balance"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "tax": "Impôt",
      "taxCode": "Code fiscal",
      "period": "Période",
      "taxAmount": "Montant de la taxe",
      "penalty": "Frais de pénalité",
      "interest": "Intérêts",
      "taxArrears": "la mûre",
      "total": "Le total",
      "expirationDate": "Date d'expiration",
      "accountType": "Type de compte",
      "balance": "Solde",
      "date": "Date",
      "transactionType": "Art der Transaktion",
      "value": "Wert",
      "document": "Document",
      "taxpayerName": "nom",
      "credit": "Crédit",
      "debit": "Débit"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "L'identifiant est requis"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "Demande de paiement",
      "paymentsByJurisdiction": "Paiements par juridiction",
      "pagePayments": "Enregistrement de paiement",
      "pageUploadPayments": "Charge des paiements",
      "selectTaxReturn": "Sélectionnez Déclaration fiscale",
      "reconciliationPayments": "Rapprochement des paiements",
      "paymentsTaxpayer": "Paiements déclarés par le contribuable",
      "paymentsTaxCollect": "Paiements déclarés par l'entité de collecte",
      "concialiation": "Conciliation",
      "checkBankInformation": "Vérifier les informations bancaires"
    },
    "label": {
      "registerPayment": "Enregistrement de paiement",
      "amountTaxReturn": "Montant de la déclaration",
      "totalDebt": "Dette totale",
      "amountTaxpayer": "Montant du contribuable",
      "amountBank": "Montant bancaire",
      "amountFrom": "Montant de",
      "amountTo": "Montant jusqu'à",
      "tax-id": "Ruc",
      "name": "nom",
      "date-from": "Dater de",
      "date-to": "Date au",
      "date-payment": "Jour de paie",
      "payment-number": "Numéro de paiement",
      "exchange-rate": "Taux de change",
      "local-amount": "Montant en devise locale",
      "tax": "Impôt",
      "amount": "Montant",
      "excelDefinition": "Définition de fichier Excel",
      "taxCollector": "Receveur des impôts",
      "swiftNumber": "Numéro de confirmation SWIFT",
      "uploadNumber": "Numéro de téléchargement",
      "hasErrors": "A des erreurs",
      "date-payment-bank": "Date de réception"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Paiement enregistré avec succès le [createDate]",
      "diferentCurrencyCode": "Vous ne pouvez pas rapprocher les paiements de devises différentes",
      "exceedsTolerance": "Dépasse la tolérance de [tolerence]% autorisée",
      "paymentGreaterThen": "Les paiements déclarés par le contribuable sont supérieurs au paiement déclaré par l'entité collectrice"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Enquête auprès des contribuables"
    },
    "label": {
      "name": "nom",
      "nit": "Numéro d'identification fiscale",
      "county": "Pays",
      "personType": "Genre de personne",
      "email": "Poster"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Type de personne",
      "businessName": "Nom ou raison sociale",
      "fullName": "Nom complet",
      "id": "Numéro d'identification",
      "taxNumber": "Numéro d'identification fiscale dans le pays de résidence",
      "phoneNumber": "Numéro de téléphone",
      "domicile": "Adresse",
      "department": "Département / Province / État",
      "addContact": "Ajouter le contact",
      "operations": "Opérations",
      "contacts": "Contacts:",
      "taxVector": "Vecteur fiscal",
      "reportVector": "Rapports",
      "generalData": "Général",
      "tax": "Impôt",
      "taxObligation": "Impôt",
      "report": "Signaler",
      "website": "Site web",
      "idTax": "Numéro d'identification fiscale dans le pays de résidence",
      "contactName-tax": "Nom du contact principal",
      "docNumberContact-tax": "Numéro d'identification du contact",
      "contactTaxIdNumber-tax": "Numéro d'identification fiscale du contact dans le pays de résidence",
      "phoneNumberContact-tax": "Numéro de téléphone du contact dans le pays de résidence",
      "email-tax": "Email du contact",
      "documents": "Documents",
      "docCompanyRegistrationNumber": "Document d'enregistrement de l'entreprise",
      "docLocalContact": "Document d'identité du contact dans le pays de résidence",
      "acceptance": "Acceptation",
      "taxpayerRequest": "Enregistrement POSS",
      "confirmTerms": "Accepter les termes et conditions",
      "terms": "Lorem ipsum douleur sit amet consectetur adipiscing elit par",
      "locale": "Langue prédéfinie",
      "queryOfRequest": "Requête de demande",
      "acquirerId": "Identifiant de l'acquéreur",
      "acquirerCountry": "Pays de l'acquéreur",
      "terminalId": "Identifiant du terminal",
      "merchantCategoryCode": "Code de catégorie du commerçant",
      "merchantId": "Identifiant du commerçant",
      "documentNumberCountryResidence": "Numéro de document dans le pays de résidence"
    },
    "vector": {
      "label": {
        "tax": "Impôt",
        "expiration": "Date d'expiration",
        "periodicity": "Périodicité",
        "startOperation": "Début de l'opération"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Au moins un contact est requis",
      "operations": "Au moins une opération est requise",
      "selectOperations": "Opérations associées",
      "withoutOperations": "Aucune opération",
      "withoutOperationsVector": "Il n'a pas de taxes associées",
      "withoutOperationsReport": "Il n'a pas de rapports associés.",
      "withoutDocuments": "Il n'y a pas de définition de fichier"
    },
    "validations": {
      "acceptance": "Le champ doit être sélectionné",
      "formComplete": "Remplissez le formulaire en entier"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Applications des contribuables",
      "approve": "Approuver la demande",
      "reject": "Rejeter la demande",
      "request-additional-info": "Demander des informations supplémentaires",
      "request": "Demander"
    },
    "label": {
      "check-digit": "Chiffre de contrôle",
      "date-from": "Dater de",
      "date-to": "Date jusqu'au",
      "request-type": "Type de demande",
      "request": "Demander",
      "type": "Nett",
      "taxpayer": "Contribuable",
      "state": "État",
      "approve": "Passe",
      "reject": "Rejeter",
      "request-additional-info": "Revenir",
      "comments": "commentaires",
      "reason": "Cause",
      "createdDate": "Date",
      "cancellationDate": "Date d'annulation"
    },
    "message": {
      "approved": "Application approuvée",
      "rejected": "Demande rejetée",
      "request-additional-info": "Demander des informations supplémentaires",
      "periodictyOutOfDate": "Une périodicité d'impôt ou de déclarations n'est pas en vigueur"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Voir les déclarations"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "taxreturnNumber": "Numéro de déclaration",
      "country": "Pays",
      "formId": "Forme",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "name": "Nom du contribuable",
      "period": "Période",
      "periodFrom": "Dater de",
      "periodTo": "Date jusqu'au",
      "active": "actif"
    },
    "header": {
      "actions": "Actions",
      "nit": "Numéro d'identification fiscale",
      "name": "Nom du contribuable",
      "taxReturnNumber": "Numéro de déclaration",
      "createDate": "Date",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "form": "Forme",
      "period": "Période",
      "active": "actif"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Registrierung aktualisieren"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Se désabonner"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Envoyer le message"
    },
    "label": {
      "nit": "NIT",
      "taxpayerName": "Nom",
      "subject": "Objet du message",
      "message": "Message"
    }
  },
  "form-administration": {
    "title": {
      "page": "Formulaire d'administration des déclarations",
      "form": "Forme",
      "versions": "Versionen"
    },
    "label": {
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "tax": "Impôt",
      "numberModifications": "Nombre d'amendements",
      "amendmentApprovalRequired": "Les modifications doivent être approuvées",
      "form": "Forme",
      "versions": "Versionen"
    },
    "header": {
      "actions": "Actions",
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "tax": "Impôt"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Des boites",
      "serviceParameters": "Paramètres de service",
      "serviceHeaders": "En-têtes de service"
    },
    "label": {
      "noFoundCells": "Le formulaire n'a pas de cellules définies",
      "code": "Code de boîte",
      "name": "Boîte de nom",
      "description": "La description",
      "section": "Section",
      "formula": "Formule",
      "order": "Ordre",
      "type": "Nett",
      "service": "Un service",
      "mandatory": "Obligatoire",
      "editable": "Modifiable",
      "visible": "Sichtbar",
      "cellPurpose": "Finalité de la cellule",
      "numeric": "Numérique",
      "currency": "Devise",
      "date": "Date",
      "list": "Prêt",
      "text": "Texte",
      "catalogType": "Type de catalogue",
      "parameterName": "nom",
      "addParameter": "Ajouter un paramètre",
      "headerName": "nom",
      "addHeader": "Ajouter un en-tête"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "form-section": {
    "labels": {
      "description": "La description",
      "order": "Ordre",
      "code": "Code",
      "sectionType": "Type de section",
      "isMultiple": "Section répétable",
      "minInstances": "Instances minimales",
      "maxInstances": "Instances maximales"
    },
    "provisioning": {
      "simple": "Simple",
      "multiple": "Multiple",
      "jurisdiction": "Juridiction"
    }
  },
  "form-version": {
    "title": {
      "page": "Version du formulaire",
      "current-account-rules": "Vérification des règles de compte"
    },
    "labels": {
      "noFoundVersion": "Il n'y a pas de version configurée",
      "version": "Ausführung",
      "formVersion": "Version du formulaire",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "formCode": "Code de formulaire",
      "formName": "Nom de forme",
      "since": "Depuis",
      "generalData": "Informations générales",
      "fields": "Des boites",
      "sections": "Sections",
      "enabled": "Activée",
      "preview": "Aperçu",
      "current-account-rules": "Vérification des règles de compte",
      "account-type-header": "Type de compte",
      "transaction-type-header": "Art der Transaktion",
      "cell-header": "Boîte",
      "account-type": "Type de compte",
      "transaction-type": "Art der Transaktion",
      "cell": "Boîte"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Aperçu",
      "year": "Période",
      "taxpayer": "Identifiant du contribuable",
      "nit": "Numéro d'identification fiscale",
      "taxpayerName": "Nom du contribuable",
      "validTestTaxpayer": "Un contribuable valide n'a pas été trouvé pour le test",
      "validTestTax": "Le contribuable n'a pas de taxe liée à ce formulaire",
      "formulaLog": "Journal des formules"
    },
    "messages": {
      "formVersionNotFound": "La version du formulaire est introuvable",
      "taxReturnExist": "La déclaration existe déjà pour cette période"
    }
  },
  "appMenu": {
    "audit-log-application-http": "Journal HTTP de l'application",
    "audit-log-security-http": "Journal HTTP de sécurité",
    "catalog": "Catalogues",
    "collection_compliance": "Recouvrement et conformité",
    "collection_statistics": "Statistiques de recouvrement",
    "compliance_statistics": "Statistiques de conformité",
    "configuration": "Paramètres",
    "configure_penalties": "Configuration des pénalités",
    "debt_collection_manage": "Voir les processus",
    "disable-tfa-to-user": "Désactiver l'authentification à deux facteurs (2FA)",
    "economy-activity": "Opérations",
    "environment-application": "Variables d'application",
    "environment-security": "Variables de sécurité",
    "home-template": "Modèle d'accueil",
    "manage-form": "Formulaires",
    "manage-report-operations": "Opérations rapports supplémentaires",
    "manage-report": "Rapports supplémentaires",
    "manage-tax-operations": "Opérations Impôts",
    "manage-tax": "Impôts",
    "management-report-payment": "Paiements",
    "management-report-taxpayer": "Contribuables",
    "management-report-taxreturn": "Déclarations de revenus",
    "management-report": "Rapports de gestion",
    "non_compliance": "Contrôle de non-conformité",
    "notifications-application": "Notifications d'application",
    "notifications-security": "Notifications de sécurité",
    "operations": "Opérations",
    "query-payments-taxofficer": "Lister les Paiements",
    "report-details": "Lister les rapports supplémentaires",
    "reports": "Déclarations de revenus",
    "security": "Sécurité",
    "send-message-taxpayer": "Envoyer un message",
    "statements-tax-officer": "Déclarations de revenus",
    "tax-official-query-amending-credit": "Compte courant",
    "taxes": "Impôts",
    "taxofficer-check-load-payments": "Vérifier les informations bancaires",
    "taxofficer-payment-record": "Enregistrement de paiement",
    "taxofficer-reconciliation-payments": "Réconciliation des paiements",
    "taxofficer-taxreturn-payments": "Paiements",
    "taxofficer-transaction-adjustment": "Ajustement de solde",
    "taxofficer-upload-payments": "Télécharger les informations bancaires",
    "taxpayer-feedback": "Retour d'information",
    "taxpayer-fields": "Champs du contribuable",
    "taxpayer-report": "Liste des contribuables",
    "taxpayer-requests": "Demandes des contribuables",
    "taxpayers": "Contribuables",
    "taxreport-report": "Lister les déclarations de revenus",
    "taxreturn-evaluation": "Révision des amendements",
    "terms-template": "Modèle de termes et conditions",
    "two-factor-authentication": "Authentification à deux facteurs",
    "user-taxpayers": "Contribuables",
    "users": "Utilisateurs"
  }
}
